import type { IconType } from 'react-icons';
import {
  FiBarChart2,
  FiBook,
  FiBriefcase,
  FiCamera,
  FiCode,
  FiCpu,
  FiGlobe,
  FiLayers,
  FiPenTool,
  FiShield,
  FiSmartphone,
  FiTarget,
  FiTrendingUp,
  FiVideo,
} from 'react-icons/fi';

const EMOJI_MAP: Record<string, IconType> = {
  '💻': FiCode,
  '🖥️': FiCode,
  '📊': FiBarChart2,
  '📈': FiTrendingUp,
  '📱': FiSmartphone,
  '🎨': FiPenTool,
  '📷': FiCamera,
  '🎥': FiVideo,
  '🔐': FiShield,
  '🛡️': FiShield,
  '🌐': FiGlobe,
  '🧠': FiCpu,
  '📚': FiBook,
  '🎯': FiTarget,
  '📦': FiLayers,
  '💼': FiBriefcase,
};

const CATEGORY_MAP: Record<string, IconType> = {
  'web-development': FiCode,
  'data-science': FiBarChart2,
  'digital-marketing': FiTrendingUp,
  'mobile-development': FiSmartphone,
  'cyber-security': FiShield,
  'graphic-design': FiPenTool,
  'photography': FiCamera,
  'video-editing': FiVideo,
  'business': FiBriefcase,
  'ai-ml': FiCpu,
};

function resolveIcon(icon?: string | null, category?: string | null): IconType {
  if (icon && EMOJI_MAP[icon]) return EMOJI_MAP[icon];

  const key = category?.toLowerCase().replace(/\s+/g, '-');
  if (key && CATEGORY_MAP[key]) return CATEGORY_MAP[key];

  return FiBook;
}

export function DataIcon({
  icon,
  category,
  className = 'size-6',
}: {
  icon?: string | null;
  category?: string | null;
  className?: string;
}) {
  const Icon = resolveIcon(icon, category);
  return <Icon className={className} aria-hidden />;
}
